export default __webpack_public_path__ + "static/banner3-93226540bb3040d212575b7002b4ee14.png";